<template>
  <div class="teacher_list">
    <div
      v-for="(i,index) in list"
      :key="index"
      class="item"
      @click="viewDetail(i)"
    >
      <div class="wrap_box">
<!--        <div class="white_space" />-->
        <img
          class="teacher_img"
          :src="i.headImg"
          mode=""
        >
        <div class="counts">
          <div class="top">
            <p
              class="font16"
              v-html="i.nickname"
            />
            <div class="point"></div>
            <p style="color: #2F72C0">{{ i.rankName ? i.rankName : '暂无' }}</p>
          </div>

          <div class="line"></div>

          <div class="introduce_box">
                    <span
                      class="intro"
                      v-html="i.introduce"
                    />
          </div>
        </div>

      </div>
    </div>
  </div>
</template>

<script>
import { defineComponent, reactive, toRefs } from 'vue'

export default defineComponent({
  name: 'TeacherList',
  props: {
    list: {
      type: Array,
      default: () => []
    }
  },
  setup (props, { emit }) {
    const router = useRouter()
    const viewDetail = (i) => {
      window.open(window.location.protocol + '//' + window.location.host + '/tch/view?id=' + i.id)
      // router.push({
      //   path: '/tch/view',
      //   query: {
      //     id: i.id
      //   }
      // })
    }
    return {
      viewDetail,
      ...toRefs(props)
    }
  }
})
</script>

<style scoped lang="scss">
.teacher_list {
  margin-top: 20px;
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 20px;
  .item {
    position: relative;
    width: 383px;
    height: 145px;
    min-height: 145px;
    box-sizing: border-box;
    border-radius: 5px;
    background: #fff;
    cursor: pointer;
    .wrap_box {
      position: absolute;
      background: #fff;
      width: 100%;
      height: 100%;
      box-sizing: border-box;
      z-index: 10;
    }
    //.white_space {
    //  width: 100%;
    //  height: 18px;
    //}
    .teacher_img, .counts {
      display: inline-block;
    }
    .teacher_img {
      width: 130px;
      height: 145px;
      object-fit: cover;
    }
    .counts {
      padding: 20px 17px;
      vertical-align: middle;
      height: 100%;
      width: 253px;
      p {
        max-width: 100px;
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
      }
      span {
        margin-right: 15px;
        color: #999999;
      }

      .line{
        margin: 15px 0;
        width: 21px;
        height: 2px;
        background: #D3D3D3;
      }

      .top{
        display: flex;
        align-items: center;
        .point{
          margin: 0 10px;
          background: #94B4E4;
          width: 5px;
          height: 5px;
          border-radius: 50%;
        }
      }

    }
    .introduce_box {
      position: relative;
      overflow : hidden;
      text-overflow: ellipsis;
      display: -webkit-box;
      -webkit-line-clamp: 2;
      -webkit-box-orient: vertical;
      word-break: break-word;
    }
    &:hover .wrap_box{
      //padding-bottom: 20px;
      z-index: 11;
      box-shadow: 0 3px 18px rgba(0, 0, 0, 0.2);
      transform: translateY(-2px);
      transition: all 0.3s;
    }
    &:hover .introduce_box{
      //-webkit-line-clamp: inherit;
    }
  }
}
</style>
